// extracted by mini-css-extract-plugin
export var paragraph = "Paragraph-module--paragraph--72otg";
export var title = "Paragraph-module--title--CoP65";